<script>
const ContactInfosCorapro = defineAsyncComponent(() => import("@/containers/contact-infos-corapro"));

export default {
  name: "ComponentParser",
  props: {
    componentName: {
      type: String,
      required: true
    }
  },
  computed: {
    componentComponent() {
      switch (this.componentName) {
        case "contact-infos-corapro":
          return ContactInfosCorapro;
        default:
          return ContactInfosCorapro;
      }
    }
  }
};
</script>

<template>
  <component :is="componentComponent" />
</template>
